import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import DurationPlusMinusToggle from '../../components/Button/DurationPlusMinusToggle';
import {currencyFormatter} from '../../util/Utils';
import ActivitySection from './ActivitySection';

const DEFAULT_ACTIVITY = {
  activity_type: 'rest',
  total: 0,
  properties: [{
    property_key: 'duration',
    property_value: 0
  }]
};

const Rest = ({activities, isLoading, onChangeActivity, onUpdateActivity}) => {
  const restType = activities.find(activity => activity.activity_type === 'rest') || DEFAULT_ACTIVITY;
  const {total, properties} = restType;
  
  const duration = properties.find(p => p.property_key === 'duration').property_value;
  
  const onChangeDuration = value => onChangeActivity('rest', 'duration', value, DEFAULT_ACTIVITY);
  
  return (
    <ActivitySection
      heading={currencyFormatter.format(total)}
      isLoading={isLoading}
      subheading="Rest"
      description="How long have you rested today?"
      nextLabel="Okay, I'm done for now"
      onNext={() => onUpdateActivity('rest', DEFAULT_ACTIVITY)}
    >
      <div>
        <DurationPlusMinusToggle value={duration} onChange={onChangeDuration}/>
      </div>
    </ActivitySection>
  );
};
Rest.propTypes = {
  activities: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onChangeActivity: PropTypes.func.isRequired,
  onUpdateActivity: PropTypes.func.isRequired
};

export default withRouter(Rest);



// WEBPACK FOOTER //
// ./src/pages/Activities/Rest.js